 <div class="wrapper">
   <div class="my-2">
      <app-categorybar></app-categorybar>
    </div>
    <!-- <div class="custombg fixed-top">
      <app-header></app-header>
      <app-breadcrumb></app-breadcrumb>
    </div> -->
    <div class="top-section d-flex w-100 section align-items-center">
      <label for="updateFrequency" class="label-style mb-0">Select Employee Skill Update Frequency (in Months):</label>&nbsp;&nbsp;
      <select id="updateFrequency" [(ngModel)]="selectedFrequency" class="dropdown-style">
        <option value="3">3 Months</option>
        <option value="6">6 Months</option>
        <option value="12">12 Months</option>
      </select>
    </div>
    <div class="top-section2 d-flex w-100 section align-items-center">
      <label for="updateGrade" class="label-style mb-0">Select levels upto which you want to send Emails:</label>&nbsp;&nbsp;
      <select id="updateGrade" [(ngModel)]="selectedGrade" class="dropdown-style ml-4">
        <option value="L2">L2 Grade</option>
        <option value="L3">L3 Grade</option>
        <option value="L4">L4 Grade</option>
      </select>
    </div>
    <div class="d-flex align-items-center mt-4">
      <div class="top-section1">
        <label for="sendEmail" class="label-style mb-0">Send Email:</label>&nbsp;&nbsp;
        <input type="radio" name="sendEmail" [(ngModel)]="sendEmail" [value]="true" > Yes
        <input type="radio" name="sendEmail" [(ngModel)]="sendEmail" [value]="false" checked class="ml-2"> No
      </div>
      <div>
        <button type="submit" class="submit-button" (click)="submitForm()">Submit</button>
      </div>
    </div>
 </div>
    
